// extracted by mini-css-extract-plugin
export default {"hide":"styles_hide__RUymT","greyed-out":"styles_greyed-out__bgpZH","archetypeSize":"styles_archetypeSize__+E+N+"};